// extracted by mini-css-extract-plugin
module.exports = {"paintingSection":"PaintingSection_paintingSection__2U5ch","caption":"PaintingSection_caption__3jGIR"};